import { QueryClient } from "@tanstack/query-core";
import { redirect } from "react-router-dom";
import { LOCAL_STORAGE_KEYS } from "@/app/localStorage/model";
import { SetErrorMessageType } from "@/app/providers/ReactContextProvider/types";
import { getLeadQueryOption } from "@/entities/lead/api/getLeadQueryOption";
import { getLoanInfoQueryOption } from "@/entities/loan/api/getLoanInfoQueryOption";
import { LoanStatus } from "@/entities/loan/model/types";
import { RouterPath } from "@/router/types";

export const paymentLoader =
  (queryClient: QueryClient, setErrorMessage: SetErrorMessageType) =>
  async () => {
    const token = localStorage.getItem(LOCAL_STORAGE_KEYS.TOKEN);

    if (!token) {
      return redirect(RouterPath.Login);
    }

    const latestLead = await queryClient.fetchQuery(
      getLeadQueryOption({
        token,
        setErrorMessage,
      }),
    );
    const leadId = latestLead?.lead_id;

    if (!leadId) {
      return redirect(RouterPath.Cabinet);
    }

    const loanInfo = await queryClient.fetchQuery(
      getLoanInfoQueryOption({
        token,
        setErrorMessage,
        leadId,
      }),
    );

    if (!loanInfo) {
      return redirect(RouterPath.Cabinet);
    }

    const isCommonPayment = loanInfo.status === LoanStatus.Operational;

    if (!isCommonPayment) {
      return redirect(RouterPath.Cabinet);
    }

    return {
      loanInfo,
    };
  };
